import { AgentSelectView } from '@/components/onboarding-sheet/agent-select-view'
import { useOnboardingSheet } from '@/components/onboarding-sheet/context'
import { CtaView } from '@/components/onboarding-sheet/cta-view'
import { StepsView } from '@/components/onboarding-sheet/steps-view'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import type { OnboardingPath } from '@/components/onboarding-sheet/context'

export const OnboardingSheet = () => {
  const { isOpen, close, view, setView, setSelectedPath } = useOnboardingSheet()

  const handleSelectPath = (path: OnboardingPath) => {
    setSelectedPath(path)
    setView('steps')
  }

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && close()}>
      <SheetContent
        className="sm:max-w-[600px] flex flex-col gap-0 p-0"
        showCloseButton={false}
      >
        <SheetHeader className="sr-only">
          <SheetTitle>Get started with Sevalla</SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-hidden">
          {view === 'cta' && <CtaView onSelectPath={handleSelectPath} />}
          {view === 'agent-select' && <AgentSelectView />}
          {view === 'steps' && <StepsView />}
        </div>
      </SheetContent>
    </Sheet>
  )
}
